"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTINEL_ADDRESS = void 0;
exports.SENTINEL_ADDRESS = '0x0000000000000000000000000000000000000001';
//# sourceMappingURL=constants.js.map